import { FC } from 'react';
import styled, { useTheme } from 'styled-components';
import Lottie from 'lottie-react';
import { isMobile } from 'react-device-detect';

const BodyBackgroundLottieContainer = styled.div`
    position: fixed;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
`;

export const BodyBackgroundLottie: FC = () => {
    const { bodyBackground } = useTheme();
    const animationData = isMobile
        ? bodyBackground.backgroundLottieMobile ??
          bodyBackground.backgroundLottie
        : bodyBackground.backgroundLottie;

    if (!animationData) {
        return null;
    }

    return (
        <BodyBackgroundLottieContainer>
            <Lottie
                animationData={animationData}
                loop
                autoplay
                rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
                style={{ width: '100%', height: '100%' }}
            />
        </BodyBackgroundLottieContainer>
    );
};
